import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import CashoutConfirmation from "./CashoutConfirmation";

export default observer(function CashoutConfirmationPopUp() {
	const store = useContext(MyBetsStoreContext);

	if (store == null) {
		return null;
	}

	if (!store.cashoutStore?.isCashoutModalOpen) {
		return null;
	}

	if (store.cashoutStore?.cashoutModalData == null) {
		return null;
	}

	return (
		<CashoutConfirmation
			isOpen={store.cashoutStore.isCashoutModalOpen}
			cashoutModalData={store.cashoutStore.cashoutModalData}
			onAccept={store.cashoutStore.cashout}
			onClose={store.cashoutStore.closeCashoutModal}
			isSubmitting={store.cashoutStore.isCashoutFormSubmitting}
		/>
	);
});
